import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { PartitionAssignPivotState } from './PartitionAssignPivotState';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";

export class PartitionEntryState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionEntry;

  Description = "Quick Sort Partition entry";
  
  private _savedState : { 
    PoppedObjects: Array<any> | undefined,
  } | undefined;

  private _context : IQuickSortContext | undefined;

  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);

    let numbers: Array<number> = this._context.AlgoStack.pop() as Array<number>;
    let lo: number = this._context.AlgoStack.pop() as number;
    let hi: number = this._context.AlgoStack.pop() as number;

    if (this._savedState === undefined) {
      this._savedState = {
        PoppedObjects: [numbers, lo, hi]
      }
    }
    else {
      this._savedState.PoppedObjects = [numbers, lo, hi];
    }
  }  
  
  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.PoppedObjects);

    this._context.AlgoStack.push(this._savedState.PoppedObjects[2]);
    this._context.AlgoStack.push(this._savedState.PoppedObjects[1]);
    this._context.AlgoStack.push(this._savedState.PoppedObjects[0]);
  }

  Exit(): void {
    this._context?.TransitionTo(new PartitionAssignPivotState());
  }

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }
}